import { render, staticRenderFns } from "./course-item.vue?vue&type=template&id=4a9420f1&scoped=true&"
import script from "./course-item.vue?vue&type=script&lang=js&"
export * from "./course-item.vue?vue&type=script&lang=js&"
import style0 from "./course-item.vue?vue&type=style&index=0&id=4a9420f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9420f1",
  null
  
)

export default component.exports